// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 20px;
    margin-top: 20px;
}

.menu-item {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 24px;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.menu-item:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
}

.menu-item-disabled {
    opacity: 0.5;
    cursor: not-allowed !important;
    background: linear-gradient(135deg, #9e9e9e 0%, #757575 100%) !important;
    position: relative;
}

.menu-item-disabled:hover {
    transform: none !important;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
}

.menu-item-disabled::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    pointer-events: none;
}

.menu-item-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
    flex-wrap: wrap;
}

.menu-icon {
    font-size: 32px;
}

.menu-item h4 {
    margin: 0;
    font-size: 18px;
    flex: 1 1;
}

.menu-item p {
    margin: 0;
    opacity: 0.9;
    font-size: 14px;
    line-height: 1.5;
}

.badge {
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.badge-warning {
    background-color: #ff9800;
    color: white;
}

.badge-disabled {
    background-color: #616161;
    color: white;
}

.badge-locked {
    background-color: #f44336;
    color: white;
    animation: pulse-locked 2s ease-in-out infinite;
}

@keyframes pulse-locked {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.6;
    }
}

.feature-locked-msg {
    margin: 10px 0 0 0;
    padding: 10px 14px;
    font-size: 13px;
    font-weight: 600;
    color: #b71c1c;
    background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
    border: 1px solid #ef9a9a;
    border-left: 4px solid #f44336;
    border-radius: 6px;
    line-height: 1.5;
    display: flex;
    align-items: center;
    gap: 8px;
}

.getting-started-list {
    line-height: 1.8;
    padding-left: 20px;
}

.getting-started-list li {
    margin-bottom: 20px;
}

.getting-started-list strong {
    color: #667eea;
    font-size: 16px;
}

.getting-started-list p {
    margin: 8px 0 0 0;
    color: #666;
    font-size: 14px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .menu-grid {
        grid-template-columns: 1fr;
    }

    .menu-item-header {
        flex-direction: column;
        align-items: flex-start;
    }

    .stats-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .activity-item {
        flex-direction: column;
        gap: 10px;
    }

    .activity-meta {
        width: 100%;
        justify-content: space-between;
    }
}

/* Realtime Section Styles */
.realtime-section {
    background: #fff;
}

.section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

.section-header h3 {
    margin: 0;
    color: #333;
}

.live-badge {
    display: flex;
    align-items: center;
    gap: 6px;
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
}

.live-dot {
    width: 8px;
    height: 8px;
    background: #fff;
    border-radius: 50%;
    animation: pulse 1.5s infinite;
}

@keyframes pulse {

    0%,
    100% {
        opacity: 1;
        transform: scale(1);
    }

    50% {
        opacity: 0.5;
        transform: scale(1.2);
    }
}

/* Stats Grid */
.stats-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
    margin-bottom: 24px;
}

.stat-box {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    border-radius: 12px;
    transition: transform 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.stat-box:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.stat-box.clickable {
    cursor: pointer;
}

.stat-box.clickable:hover {
    outline: 2px solid #667eea;
}

.stat-box i {
    font-size: 28px;
}

.stat-content {
    display: flex;
    flex-direction: column;
}

.stat-value {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.2;
}

.stat-label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.stat-conversations {
    background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
    color: #3730a3;
}

.stat-messages {
    background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
    color: #065f46;
}

.stat-sentiment {
    background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%);
    color: #9d174d;
}

.stat-escalations {
    background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
    color: #92400e;
}

.stat-response {
    background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
    color: #1e40af;
}

/* Social Media Counters */
.social-counters-section {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 24px;
}

.social-counters-section h4 {
    margin: 0 0 16px 0;
    color: #333;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.social-counters-section h4 i {
    background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 20px;
}

.social-stats-grid {
    grid-template-columns: repeat(5, 1fr) !important;
}

.stat-comments {
    background: linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%);
    color: #5b21b6;
}

.stat-auto-replied {
    background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
    color: #065f46;
}

.stat-unreplied {
    background: linear-gradient(135deg, #ffedd5 0%, #fed7aa 100%);
    color: #9a3412;
}

.stat-positive-social {
    background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
    color: #166534;
}

.stat-negative-social {
    background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
    color: #991b1b;
}

.stat-fb-dm-conversations {
    background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
    color: #1e40af;
}

.stat-fb-dm-messages {
    background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
    color: #3730a3;
}

/* Chart Card */
.chart-card {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 24px;
}

.chart-card h4 {
    margin: 0 0 16px 0;
    color: #333;
    font-size: 16px;
}

.empty-chart {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
    color: #999;
}

.empty-chart i {
    font-size: 48px;
    margin-bottom: 12px;
    opacity: 0.5;
}

.empty-chart p {
    margin: 0;
    font-size: 14px;
}

/* Recent Activity */
.recent-activity {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 20px;
}

.recent-activity h4 {
    margin: 0 0 16px 0;
    color: #333;
    font-size: 16px;
}

.activity-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.activity-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: box-shadow 0.2s ease;
}

.activity-item:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.activity-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
    color: #3730a3;
    font-size: 18px;
}

.activity-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.activity-contact {
    font-weight: 600;
    color: #333;
    font-size: 14px;
}

.activity-message {
    color: #666;
    font-size: 13px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.activity-meta {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
}

.sentiment-badge {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
}

.sentiment-positive {
    background: #d1fae5;
    color: #065f46;
}

.sentiment-neutral {
    background: #fef3c7;
    color: #92400e;
}

.sentiment-negative {
    background: #fee2e2;
    color: #991b1b;
}

.activity-time {
    font-size: 12px;
    color: #999;
}

.activity-actions {
    display: flex;
    gap: 6px;
    flex-shrink: 0;
}

.btn-view-conversation,
.btn-live-chat-activity {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border: none;
    border-radius: 10px;
    color: white;
    font-size: 15px;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    flex-shrink: 0;
}

.btn-view-conversation {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.btn-live-chat-activity {
    background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
    color: #065f46;
}

.btn-view-conversation:hover,
.btn-live-chat-activity:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.btn-view-conversation:active,
.btn-live-chat-activity:active {
    transform: scale(0.95);
}

.empty-activity {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    color: #999;
}

.empty-activity i {
    font-size: 48px;
    margin-bottom: 12px;
    opacity: 0.5;
}

.empty-activity p {
    margin: 0;
    font-size: 14px;
}

.loading-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px;
    color: #666;
    font-size: 16px;
}
.page-footer {
  text-align: center;
  padding: 24px 16px;
  margin-top: 32px;
  border-top: 1px solid #eee;
  font-size: 13px;
  color: #999;
}

.page-footer a {
  color: #999;
  text-decoration: none;
  transition: color 0.2s ease;
}

.page-footer a:hover {
  color: #667eea;
  text-decoration: underline;
}

.page-footer-separator {
  margin: 0 8px;
  color: #ccc;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,wEAAwE;IACxE,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,mDAAmD;AACvD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,SAAO;AACX;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,+CAA+C;AACnD;;AAEA;;IAEI;;QAEI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,6DAA6D;IAC7D,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA,2BAA2B;AAC3B;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;AACJ;;AAEA,4BAA4B;AAC5B;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,6DAA6D;IAC7D,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;;IAEI;;QAEI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,qBAAqB;IACzB;AACJ;;AAEA,eAAe;AACf;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,+BAA+B;IAC/B,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;IAC7D,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,cAAc;AAClB;;AAEA,0BAA0B;AAC1B;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,+EAA+E;IAC/E,6BAA6B;IAC7B,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,6DAA6D;IAC7D,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,cAAc;AAClB;;AAEA;IACI,6DAA6D;IAC7D,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,gCAAgC;AACpC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6DAA6D;IAC7D,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,qDAAqD;IACrD,cAAc;AAClB;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;IAC7D,cAAc;AAClB;;AAEA;;IAEI,qBAAqB;IACrB,yCAAyC;AAC7C;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,WAAW;IACX,eAAe;AACnB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,WAAW;AACb","sourcesContent":[".menu-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n    gap: 20px;\n    margin-top: 20px;\n}\n\n.menu-item {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    padding: 24px;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.menu-item:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);\n}\n\n.menu-item-disabled {\n    opacity: 0.5;\n    cursor: not-allowed !important;\n    background: linear-gradient(135deg, #9e9e9e 0%, #757575 100%) !important;\n    position: relative;\n}\n\n.menu-item-disabled:hover {\n    transform: none !important;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;\n}\n\n.menu-item-disabled::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.1);\n    border-radius: 12px;\n    pointer-events: none;\n}\n\n.menu-item-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 12px;\n    flex-wrap: wrap;\n}\n\n.menu-icon {\n    font-size: 32px;\n}\n\n.menu-item h4 {\n    margin: 0;\n    font-size: 18px;\n    flex: 1;\n}\n\n.menu-item p {\n    margin: 0;\n    opacity: 0.9;\n    font-size: 14px;\n    line-height: 1.5;\n}\n\n.badge {\n    padding: 4px 10px;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.badge-warning {\n    background-color: #ff9800;\n    color: white;\n}\n\n.badge-disabled {\n    background-color: #616161;\n    color: white;\n}\n\n.badge-locked {\n    background-color: #f44336;\n    color: white;\n    animation: pulse-locked 2s ease-in-out infinite;\n}\n\n@keyframes pulse-locked {\n\n    0%,\n    100% {\n        opacity: 1;\n    }\n\n    50% {\n        opacity: 0.6;\n    }\n}\n\n.feature-locked-msg {\n    margin: 10px 0 0 0;\n    padding: 10px 14px;\n    font-size: 13px;\n    font-weight: 600;\n    color: #b71c1c;\n    background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);\n    border: 1px solid #ef9a9a;\n    border-left: 4px solid #f44336;\n    border-radius: 6px;\n    line-height: 1.5;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.getting-started-list {\n    line-height: 1.8;\n    padding-left: 20px;\n}\n\n.getting-started-list li {\n    margin-bottom: 20px;\n}\n\n.getting-started-list strong {\n    color: #667eea;\n    font-size: 16px;\n}\n\n.getting-started-list p {\n    margin: 8px 0 0 0;\n    color: #666;\n    font-size: 14px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .menu-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .menu-item-header {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .stats-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .activity-item {\n        flex-direction: column;\n        gap: 10px;\n    }\n\n    .activity-meta {\n        width: 100%;\n        justify-content: space-between;\n    }\n}\n\n/* Realtime Section Styles */\n.realtime-section {\n    background: #fff;\n}\n\n.section-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n\n.section-header h3 {\n    margin: 0;\n    color: #333;\n}\n\n.live-badge {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n    color: white;\n    padding: 6px 12px;\n    border-radius: 20px;\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.live-dot {\n    width: 8px;\n    height: 8px;\n    background: #fff;\n    border-radius: 50%;\n    animation: pulse 1.5s infinite;\n}\n\n@keyframes pulse {\n\n    0%,\n    100% {\n        opacity: 1;\n        transform: scale(1);\n    }\n\n    50% {\n        opacity: 0.5;\n        transform: scale(1.2);\n    }\n}\n\n/* Stats Grid */\n.stats-grid {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n.stat-box {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 16px;\n    border-radius: 12px;\n    transition: transform 0.2s ease;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.stat-box:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n}\n\n.stat-box.clickable {\n    cursor: pointer;\n}\n\n.stat-box.clickable:hover {\n    outline: 2px solid #667eea;\n}\n\n.stat-box i {\n    font-size: 28px;\n}\n\n.stat-content {\n    display: flex;\n    flex-direction: column;\n}\n\n.stat-value {\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 1.2;\n}\n\n.stat-label {\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.stat-conversations {\n    background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);\n    color: #3730a3;\n}\n\n.stat-messages {\n    background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n    color: #065f46;\n}\n\n.stat-sentiment {\n    background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%);\n    color: #9d174d;\n}\n\n.stat-escalations {\n    background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n    color: #92400e;\n}\n\n.stat-response {\n    background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);\n    color: #1e40af;\n}\n\n/* Social Media Counters */\n.social-counters-section {\n    background: #f8f9fa;\n    border-radius: 12px;\n    padding: 20px;\n    margin-bottom: 24px;\n}\n\n.social-counters-section h4 {\n    margin: 0 0 16px 0;\n    color: #333;\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.social-counters-section h4 i {\n    background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    font-size: 20px;\n}\n\n.social-stats-grid {\n    grid-template-columns: repeat(5, 1fr) !important;\n}\n\n.stat-comments {\n    background: linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%);\n    color: #5b21b6;\n}\n\n.stat-auto-replied {\n    background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n    color: #065f46;\n}\n\n.stat-unreplied {\n    background: linear-gradient(135deg, #ffedd5 0%, #fed7aa 100%);\n    color: #9a3412;\n}\n\n.stat-positive-social {\n    background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);\n    color: #166534;\n}\n\n.stat-negative-social {\n    background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n    color: #991b1b;\n}\n\n.stat-fb-dm-conversations {\n    background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);\n    color: #1e40af;\n}\n\n.stat-fb-dm-messages {\n    background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);\n    color: #3730a3;\n}\n\n/* Chart Card */\n.chart-card {\n    background: #f8f9fa;\n    border-radius: 12px;\n    padding: 20px;\n    margin-bottom: 24px;\n}\n\n.chart-card h4 {\n    margin: 0 0 16px 0;\n    color: #333;\n    font-size: 16px;\n}\n\n.empty-chart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 200px;\n    color: #999;\n}\n\n.empty-chart i {\n    font-size: 48px;\n    margin-bottom: 12px;\n    opacity: 0.5;\n}\n\n.empty-chart p {\n    margin: 0;\n    font-size: 14px;\n}\n\n/* Recent Activity */\n.recent-activity {\n    background: #f8f9fa;\n    border-radius: 12px;\n    padding: 20px;\n}\n\n.recent-activity h4 {\n    margin: 0 0 16px 0;\n    color: #333;\n    font-size: 16px;\n}\n\n.activity-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.activity-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 16px;\n    background: white;\n    border-radius: 10px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    transition: box-shadow 0.2s ease;\n}\n\n.activity-item:hover {\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.activity-icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);\n    color: #3730a3;\n    font-size: 18px;\n}\n\n.activity-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n}\n\n.activity-contact {\n    font-weight: 600;\n    color: #333;\n    font-size: 14px;\n}\n\n.activity-message {\n    color: #666;\n    font-size: 13px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.activity-meta {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 4px;\n}\n\n.sentiment-badge {\n    padding: 4px 8px;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 600;\n}\n\n.sentiment-positive {\n    background: #d1fae5;\n    color: #065f46;\n}\n\n.sentiment-neutral {\n    background: #fef3c7;\n    color: #92400e;\n}\n\n.sentiment-negative {\n    background: #fee2e2;\n    color: #991b1b;\n}\n\n.activity-time {\n    font-size: 12px;\n    color: #999;\n}\n\n.activity-actions {\n    display: flex;\n    gap: 6px;\n    flex-shrink: 0;\n}\n\n.btn-view-conversation,\n.btn-live-chat-activity {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 34px;\n    height: 34px;\n    border: none;\n    border-radius: 10px;\n    color: white;\n    font-size: 15px;\n    cursor: pointer;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    flex-shrink: 0;\n}\n\n.btn-view-conversation {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.btn-live-chat-activity {\n    background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);\n    color: #065f46;\n}\n\n.btn-view-conversation:hover,\n.btn-live-chat-activity:hover {\n    transform: scale(1.1);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.btn-view-conversation:active,\n.btn-live-chat-activity:active {\n    transform: scale(0.95);\n}\n\n.empty-activity {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 40px;\n    color: #999;\n}\n\n.empty-activity i {\n    font-size: 48px;\n    margin-bottom: 12px;\n    opacity: 0.5;\n}\n\n.empty-activity p {\n    margin: 0;\n    font-size: 14px;\n}\n\n.loading-placeholder {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 60px;\n    color: #666;\n    font-size: 16px;\n}\n.page-footer {\n  text-align: center;\n  padding: 24px 16px;\n  margin-top: 32px;\n  border-top: 1px solid #eee;\n  font-size: 13px;\n  color: #999;\n}\n\n.page-footer a {\n  color: #999;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.page-footer a:hover {\n  color: #667eea;\n  text-decoration: underline;\n}\n\n.page-footer-separator {\n  margin: 0 8px;\n  color: #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
